import type { ReactNode } from "react";

// Stays at the top while its part of the list scrolls by
export const HaNResultListHeader = ({ title, children }: { title: string; children?: ReactNode }) => {
  return (
    <div className="sticky top-0 z-10 my-2 flex items-center justify-between bg-white px-5 py-2">
      <h3>{title}</h3>
      {children}
    </div>
  );
};
